// Entry point for the build script in your package.json
import * as ActiveStorage from "@rails/activestorage"
import "@hotwired/turbo-rails"
import "../turbo_stream_actions"
import "../controllers"

ActiveStorage.start()